module.exports = __webpack_public_path__ + "img/43_36.4d31e142.png";